import { Link, useNavigate } from "react-router-dom";

export const BreadCrumb = ({ breadCrumb }: { breadCrumb: string }) => {
  const navigate = useNavigate();
  if (location.pathname.includes("student-home")) {
    return (
      <div className="flex gap-2 mt-4 rounded-sm select-none text-sm text-gray-600">
        <Link to={"/"}>首頁</Link>
        <span>&gt;</span>
        <span className="text-primary-light">批改紀錄</span>
      </div>
    );
  } else if (location.pathname.includes("student")) {
    const breadCrumbList = breadCrumb.split("/").slice(2);
    const qs = new URLSearchParams(location.search);
    const bookName = qs.get("bookName");

    return (
      <div className="flex gap-2 mt-4 rounded-sm select-none text-sm text-gray-600">
        <Link to={"/student-home"}>首頁</Link>
        <span>&gt;</span>
        {breadCrumbList.map((item, index) => {
          // 為變數提供預設值，避免在賦值前使用
          let text: string = "";
          let path: string = "";
          switch (item) {
            case "upload":
              text = "上傳作文";
              path = "/student/upload?bookName=" + bookName;
              break;
            case "result":
              text = "批改結果";
              path = "/student/upload/result";
              break;
            default:
              text = "";
              path = "/student-home";
              break;
          }
          return (
            <span key={item} className="flex gap-2">
              <span
                onClick={() => {
                  if (index !== breadCrumbList.length - 1) {
                    navigate(path);
                  }
                }}
                className={`${
                  index !== breadCrumbList.length - 1
                    ? "cursor-pointer"
                    : "text-primary-light"
                }`}
              >
                {text}
              </span>
              {index < breadCrumbList.length - 1 && <span>&gt;</span>}
            </span>
          );
        })}
      </div>
    );
  } else if (breadCrumb === "/student/home/upload") {
    return (
      <div className="flex gap-2 mt-4 rounded-sm select-none text-sm text-gray-600">
        <Link to={"/"}>首頁</Link>
        <span>&gt;</span>
        <Link to={"/student-home"}>批改紀錄</Link>
        <span>&gt;</span>
        <span className="text-primary-light">上傳作文</span>
      </div>
    );
  } else if (breadCrumb === "/student/record/result") {
    return (
      <div className="flex gap-2 mt-4 rounded-sm select-none text-sm text-gray-600">
        <Link to={"/"}>首頁</Link>
        <span>&gt;</span>
        <Link to={"/student-home"}>批改紀錄</Link>
        <span>&gt;</span>
        <span className="text-primary-light">學生成績單</span>
      </div>
    );
  } else if (location.pathname.includes("teacher") || location.pathname === "/book-preview" || breadCrumb.includes("teacher")) {
    const breadCrumbList = breadCrumb.split("/").slice(2);
    return (
<div className="flex gap-2 mt-4 rounded-sm select-none text-sm text-gray-600">
        <Link to={"/"}>首頁</Link>
        <span>&gt;</span>
        {breadCrumbList.length === 0 || breadCrumbList[0] === "book-preview" ? (
          <span className="text-primary-light">題目清單</span>
        ) : (
          <>
            <Link to={"/book-preview"}>題目清單</Link>
            <span>&gt;</span>
          </>
        )}
        {breadCrumbList.length > 0 && breadCrumbList[0] !== "book-preview" && breadCrumbList.map((item, index) => {
          // 為變數提供預設值，避免在賦值前使用
          let text: string = "";
          let path: string = "";
          switch (item) {
            case "book-preview":
              text = "題目清單";
              path = "/book-preview";
              break;
            case "correcting-records":
              text = "檢視紀錄";
              path = "/teacher/correcting-records";
              break;
            case "result":
              text = "學生成績單";
              path = "/teacher/correcting-records/result";
              break;
            default:
              text = "";
              path = "/teacher-home";
              break;
          }
          return (
            <span key={item} className="flex gap-2">
              <span
                onClick={() => {
                  if (index !== breadCrumbList.length - 1) {
                    navigate(path);
                  }
                }}
                className={`${
                  index !== breadCrumbList.length - 1
                    ? "cursor-pointer"
                    : "text-primary-light"
                }`}
              >
                {text}
              </span>
              {index < breadCrumbList.length - 1 && <span>&gt;</span>}
            </span>
          );
        })}
      </div>
    );
  } else {
    return null;
  }
};